import { gql } from "@apollo/client";
import {
  InternalCuratedSearchFilters,
  StartFromPriorInternalSearchRow_AutopilotSessionFragment,
} from "../../../../../__generated__/graphql";
import classnames from "classnames";
import CiroButton, { CiroButtonStyleEnum } from "../../../../shared/CiroButton";
import { AutopilotCuratedInternalSearchContext_InternalSearchFilters } from "../../../../../contexts/AutopilotCuratedInternalSearchContext";
import { useContext } from "react";
import AutopilotCuratedSearchContext from "../../../../../contexts/AutopilotCuratedSearchContext";
import toast from "react-hot-toast";
import { dateToTimeAgo } from "../../../../../utils/formatters";

export const StartFromPriorInternalSearchRow_AutopilotSession = gql`
  fragment StartFromPriorInternalSearchRow_AutopilotSession on AutopilotSession {
    id
    name
    created_at
    curatedSearch {
      id
      prompt
      internalCuratedSearch {
        filters {
          ...AutopilotCuratedInternalSearchContext_InternalSearchFilters
        }
      }
      scoringCriteria {
        criterion
      }
    }
  }
  ${AutopilotCuratedInternalSearchContext_InternalSearchFilters}
`;

const StartFromPriorInternalSearchRow = ({
  session,
  onClose,
  setSavedFilters,
}: {
  session: StartFromPriorInternalSearchRow_AutopilotSessionFragment;
  onClose: () => void;
  setSavedFilters: (filters: InternalCuratedSearchFilters) => void;
}) => {
  const {
    setSelectedPrompt,
    setStartedGeneratingFilters,
    setScoringCriteriaValues,
  } = useContext(AutopilotCuratedSearchContext);

  return (
    <CiroButton
      analyticsField="Start from prior search selected"
      analyticsProps={{
        sessionId: session.id,
        sessionName: session.name,
      }}
      onClick={() => {
        setSelectedPrompt(session.curatedSearch?.prompt ?? "");

        const filters = session.curatedSearch?.internalCuratedSearch?.filters;
        const scoringCriteria = session.curatedSearch?.scoringCriteria;

        if (filters) {
          setSavedFilters(filters);
        } else {
          toast.error("No filters found for this search");
        }

        if (scoringCriteria) {
          setScoringCriteriaValues(
            scoringCriteria?.map((criterion) => criterion.criterion),
          );
        } else {
          toast.error("No scoring criteria found for this search");
        }

        setStartedGeneratingFilters(true);
        onClose();
      }}
      style={CiroButtonStyleEnum.UNSTYLED}
    >
      <div
        className={classnames(
          "flex",
          "flex-col",
          "gap-2",
          "rounded-lg",
          "p-4",
          "bg-gray-100",
          "border-1",
          "border-gray-200",
          "hover:bg-gray-200",
          "items-start",
        )}
      >
        <div className={classnames("text-sm", "text-gray-500")}>
          Last run {dateToTimeAgo(session.created_at)}
        </div>
        <div className={classnames("text-sm", "text-gray-900")}>
          {session.name}
        </div>
      </div>
    </CiroButton>
  );
};

export default StartFromPriorInternalSearchRow;
